import { defaultApi } from '@/plugins/api/defaultApi'

export default {
  name: 'news',
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    async getNewses({}, { pageSize, ordering }) {
      const { data } = await defaultApi.getNews({ pageSize, ordering })
      return data
    },
  },
}
